import TipoVehiculoCatalog from './TipoVehiculoCatalog';

export default function TipoVehiculoPage() {
    return (
        <div>
            <TipoVehiculoCatalog />
        </div>
    );
}
